<mat-form-field subscriptSizing="dynamic">
    <mat-label *ngIf="label">{{label}}</mat-label>
    <input [mtxDatetimepicker]="dateTimePicker"
           [(ngModel)]="value"
           [disabled]="disabled"
           [required]="required"
           (dateChange)="dateChanged($event)"
           matInput>
    <mtx-datetimepicker #dateTimePicker
                        [type]="type"
                        [mode]="mode"
                        [twelvehour]="twelvehour"
                        [timeInterval]="timeInterval"
                        [touchUi]="touchUi"
                        [timeInput]="timeInput">
    </mtx-datetimepicker>
    <mtx-datetimepicker-toggle [for]="dateTimePicker"
                               class="st-time-control-toggle"
                               [disabled]="disabled"
                               matSuffix>
    </mtx-datetimepicker-toggle>
    <ng-container *ngIf="hasSuffix"
                  matSuffix>
        <ng-content select="[suffix]"></ng-content>
    </ng-container>
    <ng-container *ngIf="hasPrefix"
                  matPrefix>
        <ng-content select="[prefix]"></ng-content>
    </ng-container>
    <ng-container *ngIf="hasError"
                  matError>
        <ng-content select="[error]"></ng-content>
    </ng-container>
</mat-form-field>